import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: ${(props) => props.theme.officeTheme.semanticColors.bodyBackground};
  overflow-y: hidden;
`;

export const CommandBarRow = styled.div`
  display: flex;
  align-items: center;
  height: 44px;
  padding: 0 16px;
  gap: 16px;
  flex-shrink: 0;
`;

export const GrayStrip = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin: 0 12px;
  padding: 0 12px;
  border-radius: 6px;
  height: 40px;
  background-color: ${(props) => props.theme.officeTheme.palette.neutralLight};
`;

export const FilterBarRow = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  gap: 4px;
`;

export const Grid = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

  .ms-List-cell {
    display: flex;
    align-items: center;
    padding: 0 16px;
    height: 42px;
    /* Separator between every body row, matching the header's bottom border. */
    border-bottom: 1px solid ${(props) => props.theme.officeTheme.palette.neutralLight};
  }
`;

export const HeaderShimmerRow = styled.div`
  display: flex;
  align-items: center;
  height: 42px;
  box-sizing: border-box;
  border-bottom: 1px solid ${(props) => props.theme.officeTheme.palette.neutralLight};
  padding: 0 16px;
`;
